import { Component, Renderer2, OnDestroy } from '@angular/core';
import { TitleBarComponent } from '../../base/shared/title-bar/title-bar.component';
import { DashboardOversightComponent } from './dashboard-oversight/dashboard-oversight.component';

@Component({
    selector: 'app-home',
    templateUrl: './home.component.html',
    styleUrls: ['./home.component.scss'],
    imports: [TitleBarComponent, DashboardOversightComponent]
})
export class HomeComponent implements OnDestroy {
  public cellSpacing: number[] = [10, 10];

  constructor(private renderer: Renderer2) {
    this.renderer.addClass(document.body, 'body-home');
  }

  ngOnDestroy() {
    this.renderer.removeClass(document.body, 'body-home');
  }
}
